var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26752",
    "data-name": "Group 26752",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108.515,
    height: 106.614,
    viewBox: "0 0 108.515 106.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12004",
    "data-name": "Rectangle 12004",
    width: 108.515,
    height: 106.614,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26751",
    "data-name": "Group 26751",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23324",
    "data-name": "Path 23324",
    d: "M86,26.171A18.715,18.715,0,1,0,104.7,45.23,18.752,18.752,0,0,0,86,26.171m.519,34.851a16.135,16.135,0,1,1,15.619-16.414A16.131,16.131,0,0,1,86.516,61.022",
    transform: "translate(-9.117 -3.549)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23325",
    "data-name": "Path 23325",
    d: "M87.822,54.223a7.576,7.576,0,0,1-7.68-7.537,7.589,7.589,0,0,1,7.441-7.625,7.646,7.646,0,0,1,7.74,7.45v0a7.648,7.648,0,0,1-7.362,7.711h-.14m-.134-12.57h-.069a4.924,4.924,0,0,0-3.478,1.521,4.856,4.856,0,0,0-1.405,3.471,5,5,0,1,0,4.953-4.993",
    transform: "translate(-10.869 -5.298)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23326",
    "data-name": "Path 23326",
    d: "M57.868,119.73V118.41H56.7c-2.895,0-5.789.006-8.683,0-1.135,0-1.7-.456-1.688-1.293s.6-1.286,1.721-1.287q12.494-.009,24.988,0c1.1,0,1.7.5,1.688,1.321S74.141,118.4,73,118.406c-2.858.009-5.717,0-8.576,0H63.214v1.321c1.631,0,3.211,0,4.791,0,.387,0,.859-.106,1.142.073.425.269.976.735,1,1.14s-.479.921-.869,1.25c-.219.184-.675.115-1.024.115q-7.411.009-14.823,0a5.019,5.019,0,0,1-.74-.023,1.234,1.234,0,0,1-1.182-1.269,1.183,1.183,0,0,1,1.265-1.271c1.2-.029,2.4-.016,3.6-.019h1.5",
    transform: "translate(-6.284 -15.708)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23327",
    "data-name": "Path 23327",
    d: "M39.662,118.4c-.845,0-1.691.013-2.535-.005a1.268,1.268,0,0,1-.079-2.533c1.793-.064,3.591-.06,5.384,0a1.169,1.169,0,0,1,1.154,1.278,1.2,1.2,0,0,1-1.284,1.253c-.88.022-1.761.005-2.641,0",
    transform: "translate(-4.865 -15.708)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23328",
    "data-name": "Path 23328",
    d: "M84.492,118.4c-.81,0-1.62.005-2.43,0a1.207,1.207,0,0,1-1.342-1.2,1.219,1.219,0,0,1,1.295-1.362c1.689-.046,3.38-.038,5.07-.005a1.288,1.288,0,1,1-.058,2.57c-.845,0-1.69,0-2.535,0",
    transform: "translate(-10.948 -15.707)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23329",
    "data-name": "Path 23329",
    d: "M125.166,111.593a3.741,3.741,0,0,1-.571.6,1.072,1.072,0,0,1-1.654-.245,1.926,1.926,0,0,1,.008-1.6,1.082,1.082,0,0,1,1.66-.224,3.392,3.392,0,0,1,.558.618Z",
    transform: "translate(-16.651 -14.898)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23330",
    "data-name": "Path 23330",
    d: "M48.492,29.249c-2.638-3.829-2.447-7.708.456-10.258a7.131,7.131,0,0,1,9.481,0c2.23,1.978,3.723,6.185.415,10.278l3.4,1.005a13.572,13.572,0,0,1-1.289,1.806,1.307,1.307,0,0,1-1.071.153,22.887,22.887,0,0,0-14.353.646A22.4,22.4,0,0,0,31.03,53.622c-.068,6.783-.017,13.566-.017,20.349a5.79,5.79,0,0,1-3.121,5.6,8.266,8.266,0,0,1-3.048.717,7.679,7.679,0,0,0-7.3,6.742c-.238,1.705.411,2.493,2.1,2.494q34.022.005,68.042,0c1.678,0,2.24-.613,2.125-2.262a7.6,7.6,0,0,0-6.849-6.931,11.447,11.447,0,0,1-2.708-.415,5.177,5.177,0,0,1-3.774-4.668c-.2-3.406-.054-6.833-.054-10.374L78.956,65v1.134c0,2.614-.005,5.229,0,7.842,0,2.334,1.1,3.569,3.411,3.7a10.459,10.459,0,0,1,7.482,3.452,9.943,9.943,0,0,1,2.595,6.551,4.213,4.213,0,0,1-3.96,4.408c-.421.035-.847.031-1.271.032q-33.543,0-67.088,0c-.459,0-.92,0-1.376-.045a4.2,4.2,0,0,1-3.82-4.1,10.2,10.2,0,0,1,8.83-10.162q.526-.062,1.054-.107c2.573-.217,3.605-1.344,3.607-3.973,0-6.324.113-12.649-.022-18.97A25.167,25.167,0,0,1,48.142,29.428a1.768,1.768,0,0,0,.35-.18m9.695-4.974A4.506,4.506,0,1,0,53.7,28.816a4.523,4.523,0,0,0,4.488-4.541",
    transform: "translate(-2.025 -2.331)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23331",
    "data-name": "Path 23331",
    d: "M47.564,109.478,46.3,106.9c.949,0,1.687-.043,2.416.024a1.229,1.229,0,0,1,.7.507,4.519,4.519,0,0,0,7.539.01,1.657,1.657,0,0,1,1.017-.522,16.758,16.758,0,0,1,2.1-.023l-1.27,2.58H98.369c.283,0,.657-.109.83.03.421.339,1.024.786,1.036,1.2s-.547.926-.955,1.278c-.187.16-.613.048-.93.048H13.163a4.524,4.524,0,0,1-.846-.017c-.717-.14-1.236-.618-1.046-1.321.126-.468.662-.862,1.089-1.194.177-.137.547-.028.83-.028H47.564Z",
    transform: "translate(-1.523 -14.495)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23332",
    "data-name": "Path 23332",
    d: "M6.656,112.431a7.234,7.234,0,0,1-1.052-.009,1.2,1.2,0,0,1-1.125-1.3A1.172,1.172,0,0,1,5.674,109.9c.665-.036,1.335-.025,2-.007a1.18,1.18,0,0,1,1.275,1.248,1.2,1.2,0,0,1-1.24,1.294c-.349.029-.7.005-1.054.005v-.01",
    transform: "translate(-0.607 -14.902)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23333",
    "data-name": "Path 23333",
    d: "M118.138,109.888c.281,0,.562,0,.843,0a1.2,1.2,0,0,1,1.345,1.29,1.231,1.231,0,0,1-1.383,1.265c-.562.007-1.124.005-1.686,0a1.226,1.226,0,0,1-1.393-1.251c-.015-.888.543-1.32,1.431-1.308.281,0,.562,0,.843,0",
    transform: "translate(-15.714 -14.904)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23334",
    "data-name": "Path 23334",
    d: "M1.269,109.879a1.211,1.211,0,0,1,1.252,1.281,1.161,1.161,0,0,1-1.256,1.265A1.17,1.17,0,0,1,0,111.162a1.221,1.221,0,0,1,1.269-1.283",
    transform: "translate(0 -14.903)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23335",
    "data-name": "Path 23335",
    d: "M122.331,40.531a1.261,1.261,0,1,1-1.25-1.248,1.265,1.265,0,0,1,1.25,1.248m-1.255-.525a.54.54,0,0,0-.541.545.531.531,0,0,0,.514.539.542.542,0,1,0,.027-1.083",
    transform: "translate(-16.249 -5.328)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23336",
    "data-name": "Path 23336",
    d: "M29.264,33.347a1.261,1.261,0,1,1-1.25-1.247,1.265,1.265,0,0,1,1.25,1.247m-1.255-.524a.54.54,0,0,0-.541.545.531.531,0,0,0,.514.539.542.542,0,1,0,.027-1.083",
    transform: "translate(-3.627 -4.354)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23337",
    "data-name": "Path 23337",
    d: "M119.44,7.95A1.261,1.261,0,1,1,118.19,6.7a1.265,1.265,0,0,1,1.25,1.247m-1.255-.524a.54.54,0,0,0-.541.545.531.531,0,0,0,.514.539.542.542,0,1,0,.027-1.083",
    transform: "translate(-15.857 -0.909)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23338",
    "data-name": "Path 23338",
    d: "M47.341,1.993A1.913,1.913,0,1,1,45.445.1a1.921,1.921,0,0,1,1.9,1.893m-1.9-.8a.822.822,0,0,0-.821.827.806.806,0,0,0,.781.816.831.831,0,0,0,.853-.8.841.841,0,0,0-.813-.844",
    transform: "translate(-5.902 -0.014)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23339",
    "data-name": "Path 23339",
    d: "M89.261,16.156a1.913,1.913,0,1,1-1.9-1.893,1.921,1.921,0,0,1,1.9,1.893m-1.9-.8a.82.82,0,0,0-.821.826.806.806,0,0,0,.781.816.831.831,0,0,0,.853-.8.84.84,0,0,0-.813-.843",
    transform: "translate(-11.587 -1.934)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23340",
    "data-name": "Path 23340",
    d: "M6.2,35.767H2.473a.216.216,0,1,1,0-.432H6.2a.216.216,0,1,1,0,.432",
    transform: "translate(-0.306 -4.792)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23341",
    "data-name": "Path 23341",
    d: "M5.476,37.087a.214.214,0,0,1-.182-.1L3.283,33.855a.216.216,0,0,1,.363-.233l2.011,3.132a.215.215,0,0,1-.065.3.211.211,0,0,1-.117.035",
    transform: "translate(-0.441 -4.547)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23342",
    "data-name": "Path 23342",
    d: "M3.464,37.087a.211.211,0,0,1-.117-.035.215.215,0,0,1-.065-.3l2.011-3.132a.216.216,0,0,1,.363.233L3.646,36.987a.214.214,0,0,1-.182.1",
    transform: "translate(-0.441 -4.546)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23343",
    "data-name": "Path 23343",
    d: "M21.375,8.609H20.312l.575-.895a.156.156,0,1,0-.263-.169l-.6.93-.6-.93a.156.156,0,1,0-.264.169l.575.895H18.676a.156.156,0,0,0,0,.313H19.74l-.575.895a.157.157,0,0,0,.048.216.151.151,0,0,0,.085.025.155.155,0,0,0,.131-.073l.6-.93.6.93a.153.153,0,0,0,.131.073.147.147,0,0,0,.084-.025.155.155,0,0,0,.048-.216l-.574-.895h1.062a.156.156,0,0,0,0-.313",
    transform: "translate(-2.512 -1.014)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23344",
    "data-name": "Path 23344",
    d: "M76.195,2.232H72.953a.188.188,0,1,1,0-.376h3.241a.188.188,0,1,1,0,.376",
    transform: "translate(-9.869 -0.252)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23345",
    "data-name": "Path 23345",
    d: "M75.568,3.381a.188.188,0,0,1-.158-.086L73.658.567a.188.188,0,1,1,.315-.2l1.752,2.728a.187.187,0,0,1-.057.259.178.178,0,0,1-.1.03",
    transform: "translate(-9.986 -0.038)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23346",
    "data-name": "Path 23346",
    d: "M73.815,3.381a.178.178,0,0,1-.1-.03.187.187,0,0,1-.057-.259L75.409.363a.188.188,0,1,1,.316.2L73.974,3.294a.188.188,0,0,1-.158.086",
    transform: "translate(-9.986 -0.037)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23347",
    "data-name": "Path 23347",
    d: "M95.788,1.955H92.546a.188.188,0,1,1,0-.376h3.241a.188.188,0,1,1,0,.376",
    transform: "translate(-12.526 -0.214)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23348",
    "data-name": "Path 23348",
    d: "M95.16,3.1A.188.188,0,0,1,95,3.017L93.25.29a.188.188,0,1,1,.316-.2l1.752,2.728a.187.187,0,0,1-.057.259.178.178,0,0,1-.1.03",
    transform: "translate(-12.643 0)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23349",
    "data-name": "Path 23349",
    d: "M93.408,3.1a.179.179,0,0,1-.1-.03.187.187,0,0,1-.057-.259L95,.086a.188.188,0,1,1,.315.2L93.566,3.017a.188.188,0,0,1-.157.086",
    transform: "translate(-12.643 0)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23350",
    "data-name": "Path 23350",
    d: "M114.935,23.478h-2.941a.171.171,0,0,1,0-.341h2.941a.171.171,0,0,1,0,.341",
    transform: "translate(-15.166 -3.138)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23351",
    "data-name": "Path 23351",
    d: "M114.365,24.521a.17.17,0,0,1-.143-.079l-1.589-2.475a.17.17,0,0,1,.287-.184l1.589,2.475a.17.17,0,0,1-.052.235.161.161,0,0,1-.092.028",
    transform: "translate(-15.272 -2.944)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23352",
    "data-name": "Path 23352",
    d: "M112.776,24.521a.161.161,0,0,1-.092-.028.17.17,0,0,1-.052-.235l1.589-2.475a.17.17,0,0,1,.287.184l-1.589,2.475a.17.17,0,0,1-.143.079",
    transform: "translate(-15.272 -2.944)",
    fill: "#ff3d00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonotification);
export default __webpack_public_path__ + "static/media/nonotification.fd8e37cb3c708fc0ab824e338b4aec89.svg";
export { ForwardRef as ReactComponent };